import SettingsContent from '../Wrapper';
import CrmConfigsHome from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/crm-configs'),
      component: SettingsContent,
      props: {
        headerTitle: 'CRM_CONFIGS.HEADER',
        icon: 'globe',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'crm_configs_wrapper',
          roles: ['administrator', 'agent'],
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'crm_configs_list',
          roles: ['administrator', 'agent'],
          component: CrmConfigsHome,
        },
      ],
    },
  ],
};
